// extracted by mini-css-extract-plugin
export default {"profileContainer":"styles_profileContainer__cT1Cd","profileDetails":"styles_profileDetails__codlQ","profileImg":"styles_profileImg__d49rH"};